import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } className={props?.className} icon={props?.icon}>{ children }</Button>
}